import * as ng from '@angular/core'
import { Component, ViewChild } from '@angular/core'
import * as Rx from 'rxjs'
import { Router } from '@angular/router'
import { environment } from 'src/env/environment'
import { LiveUserAuthority } from 'src/lib/entity/live-user-authority'
import { MagliveApiClient } from 'src/lib/api-client/maglive-api-client'
import { Live, CreatorList } from 'src/lib/entity/live'
import { AdminSidebarComponent } from 'src/app/parts/admin/sidebar/admin-sidebar.component'

import { FirestoreAccess } from 'src/lib/firestore-access'
import { CommonService } from 'src/lib/services/common-service'

@Component({
  templateUrl: './admin-page.component.html',
  styleUrls: ['./admin-page.component.scss'],
  providers: [CommonService],
})
export class AdminPageComponent implements ng.OnInit {
  @ViewChild(AdminSidebarComponent)
  adminSidebarComponent: AdminSidebarComponent
  @ng.ViewChild('container', { static: false })
  container: ng.ElementRef<HTMLDivElement>

  baseURL = environment.baseURL
  loginCallbackURL =
    environment.baseURL.mag2mypage + 'Welcome.do?ref=' + window.location.href
  envName: string | undefined
  authority: LiveUserAuthority | 'NOT_ADMIN'

  // クリエイター一覧データ
  // TODO 読み込みが遅いため親コンポーネントに設置
  creatorList: CreatorList[]
  creatorList$: Rx.Observable<CreatorList[] | 'NOT_FOUND'>

  // ページネーション用
  endPage: number
  pages: number[]
  maxDisplayCount = 10

  // アーカイブアップロード用
  private archiveUploadProcessList: Live[] = []

  constructor(
    private router: Router,
    private commonService: CommonService,
    private firestoreAccess: FirestoreAccess
  ) {
    document.body.style.backgroundColor = 'white'
  }

  ngOnInit() {
    MagliveApiClient.getAuthority().subscribe((authorities) => {
      // 未ログインなのでログインページにリダイレクト
      if (authorities === 'NOT_LOGIN') {
        window.location.href = this.loginCallbackURL
        return
      }

      // 管理者ではないので 404 などを表示する
      if (!authorities.privileges || authorities.privileges.length === 0) {
        console.log(this.baseURL)
        Rx.from(this.router.navigateByUrl('/not-found'))
        return
      }

      this.envName = this.getEnvName()
      this.authority = authorities
      this.commonService.setAuthority(this.authority)
      this.reloadCreatorList()
    })

    this.firestoreAccess.getArchiveUploadingLives().subscribe((x) => {
      this.archiveUploadProcessList = x
    })
  }

  private getEnvName(): string {
    if (environment.name === 'stage') {
      return 'stg'
    } else if (environment.name === 'production') {
      return 'prod'
    } else {
      return 'local'
    }
  }

  private reloadCreatorList(): void {
    this.creatorList$ = MagliveApiClient.getCreatorList()
    this.creatorList$.subscribe((x) => {
      if (x !== 'NOT_FOUND') {
        this.creatorList = x
        this.commonService.setCreatorList(this.creatorList)
      }
    })
  }

  toggleSidebar() {
    this.container.nativeElement.classList.toggle('sb-sidenav-toggled')
    this.adminSidebarComponent.toggleSidebar()
  }

  private resetUploadStatus(liveId: string) {
    MagliveApiClient.updateArchiveUploadStatusByFetch(liveId, 'INIT')
  }

  /**
   * ブラウザを閉じる前・リロード前に、アップロード中のライブがある場合に確認ダイアログを出す
   * @param e イベント
   */
  @ng.HostListener('window:beforeunload', ['$event'])
  beforeunloadHandler(e: Event) {
    const filter = this.archiveUploadProcessList.filter((live) => {
      return (
        (live.archiveUploadStatus === 'PROGRESS' && live?.roomId == null) ||
        (live?.archiveUploadStatus === 'COMPLETED' && live?.roomId == null)
      )
    })

    if (filter.length > 0) {
      e.returnValue = true
    }
  }

  /**
   * 上記の確認ダイアログでOKとした場合、アップロード中である全ライブのアップロードステータスを初期化する
   */
  @ng.HostListener('window:unload', ['$event'])
  unloadHandler() {
    const filter = this.archiveUploadProcessList.filter((live) => {
      return (
        (live.archiveUploadStatus === 'PROGRESS' && live?.roomId == null) ||
        (live?.archiveUploadStatus === 'COMPLETED' && live?.roomId == null)
      )
    })

    if (filter.length > 0) {
      filter.forEach((live) => {
        this.resetUploadStatus(live.id)
      })
    }
  }
}
